module.exports = __webpack_public_path__ + "img/seeking-alpha-dark.c89f82f0.png";